var commissions = [
  {key: 'membership', label:'Membresía'},
  {key: 'sale_date', label:'Fecha de la venta'},
  {key: 'location', label:'Sala de ventas'},
  {key: 'volume', label:'Volumen sin IVA'},
  {key: 'payed', label:'Pagado($)'},
  {key: 'percentage_payed', label:'Pagado(%)'},
  {key: 'percentage_agreed', label:'Pactado(%)'},
  {key: 'roles', label:'Roles del empleado'},
  {key: 'will_be_payed', label:'Comisiones pagables por rol'},
  {key: 'split_fractions', label:'Fracciones de casados'},
  {key: 'rules', label:'Grupo de reglas del empleado'},
  {key: 'rules_effective_date', label:'Reglas del'},
  {key: 'employee_commission_level', label:'Nivel de comisión del empleado'},
  {key: 'rules_applied', label:'Reglas aplicadas'},
  {key: 'free_weeks', label: 'Free Weeks'},
  {key: 'fractions_to_be_payed', label:'Fracciones según % pagado'},
  {key: 'half_commission_thresholds', label:'% para entregar media comisión'},
  {key: 'full_commission_thresholds', label:'% para entregar comisión completa'},
  {key: 'complete_commissions', label:'Comisiones completas'}
]
export const breakdownDetails = {
  base_salary: [
    {key:'days_worked', label:'Días trabajados'},
    {key:'reason',label:'Descripción'},
    {key:'monthly_salary', label:'Salario mensual', money:true}
  ],
  fixed_bonus: [
    {key:'description', label:'Descripción'},
  ],
  default_penalties: [
    {key:'reason', label:'Concepto'},
  ],
  weekly_bonus: [
    {key:'reason', label:'Concepto'},
  ],
  extras: [
    {key: 'title', label:'Razón'},
    {key: 'description', label:'Descripción'},
    {key: 'user', label:'Agregado por'}
  ],
  adjustment_with_discount: [
    {key: 'title', label:'Razón'},
    {key: 'description', label:'Descripción'},
    {key: 'user', label:'Agregado por'}
  ],
  discounts: [
    {key: 'title', label:'Razón'},
    {key: 'description', label:'Descripción'},
    {key: 'user', label:'Agregado por'}
  ],
  loans: [
    {key: 'reference_info', label:'Referencia'}
  ],
  loan_payments: [
    {key: 'id', label: 'Tipo'},
    {key: 'initial_debt', label:'Deuda inicial', money:true},
    // {key: 'owes', label:'Abonado', money:true},
    {key: 'payment', label:'Abono', money:true},
    {key: 'owed_after', label:'Saldo deudor', money:true},
  ],
  infonavit: [
    {key: 'id', label: 'Tipo'},
    // {key: 'initial_debt', label:'Deuda inicial', money:true},
    // {key: 'owes', label:'Debido antes', money:true},
    {key: 'default_amount', label:'Abono', money:true},
    // {key: 'owed_after', label:'Debido después', money:true},
  ],
  new_sales_commissions: commissions,
  upgrades_commissions: commissions,
  payments_commissions:[
    {key: 'membership', label:'Membresia'},
    {key:'sale_date', label:'Fecha de venta'},
    {key:'payment_date',label:'Fecha de pago'},
    {key:'half_commission_threshold',label:'Comisión pendiente'},
    // {key:'corresponding_now',label:'Comisión pendiente'},
    // {key:'complete_commission',label:'Comisión pendiente'},
    // {key:'amount',label:'Comisión pendiente',money:true},
    // {key:'percentage_payed',label:'Comisión pendiente'},
    // {key:'percentage_payed_previously',label:'Comisión pendiente'},
  ],
  payer: [
    {key: 'percentage', label:'%'},
    {key: 'base_salary', label:'Salario base', money:true},
    {key: 'adjustment_with_discount', label:'Bono con descuento', money:true},
    {key: 'new_sales_commissions', label:'Comisiones por ventas nuevas', money:true},
    {key: 'payments_commissions', label:'Comisiones por pagos a enganche', money:true},
    {key: 'upgrades_commissions', label:'Comisiones por upgrades', money:true},
    {key: 'qs_commissions', label:'Comisiones por parejas', money:true},
    {key: 'override', label:'Override', money:true}
  ],
  cancelations_and_downgrades: [
    {key: 'warning', label:'Retroactivo ajustado'},
    {key: 'cancelling_fund_discount', label:'Descuento al fondo de cancelación', money:true},
    {key: 'previous_movement_date', label:'Fecha de movimiento anterior'},
    {key: 'membership', label:'Membresía'},
    {key: 'type', label:'Tipo'}
  ],
  cancelling_fund: [
    {key: 'previous_balance', label: 'Abonado', money:true},
    {key: 'payment', label: 'Abono', money:true},
    // {key: 'previously_owed', label: 'Saldo deudor', money:true},
    // {key: 'period_discount', label: 'Impacto al fondo por cancelaciones del periodo', money:true},
    // {key: 'owed_with_discount', label: 'Debido antes con impactos', money:true},
    {key: 'owed_after_payment', label: 'Saldo deudor', money:true},
    {key: 'percentage', label:'%'},
    {key: 'base_salary', label:'Salario base', money:true},
    {key: 'adjustment_with_discount', label:'Bono con descuento', money:true},
    {key: 'new_sales_commissions', label:'Comisiones por ventas nuevas', money:true},
    {key: 'payments_commissions', label:'Comisiones por pagos a enganche', money:true},
    {key: 'upgrades_commissions', label:'Comisiones por upgrades', money:true},
    {key: 'qs_commissions', label:'Comisiones por parejas', money:true},
    {key: 'override', label:'Override', money:true}
  ],
  cancelling_fund_wp: [
    {key: 'previous_balance', label: 'Abonado', money:true},
    {key: 'payment', label: 'Abono', money:true},
    // {key: 'previously_owed', label: 'Saldo deudor', money:true},
    // {key: 'period_discount', label: 'Impacto al fondo por cancelaciones del periodo', money:true},
    // {key: 'owed_with_discount', label: 'Debido antes con impactos', money:true},
    {key: 'owed_after_payment', label: 'Saldo deudor', money:true},
    {key: 'percentage', label:'%'},
    {key: 'weekly_bonus', label:'Bono fijo', money:true},
    {key: 'fixed_bonus', label:'Bono mensual', money:true},
    {key: 'extras', label:'Extras', money:true},
    {key: 'administrative_commission', label:'Comisiones', money:true},
    {key: 'spiffs', label:'Spiff', money:true},
  ],
  paid_cancellation_fund: [
    {key: 'balance', label: 'Abonado', money:true},
  ],
  spiffs: [
    {key: 'title', label:'Razón'},
    {key: 'description', label:'Descripción'},
    {key: 'user', label:'Agregado por'}
  ],
  tips: [
    {key: 'title', label:'Razón'},
    {key: 'description', label:'Descripción'},
    {key: 'user', label:'Agregado por'}
  ],
  administrative_commission:[
    {key: 'title', label:'Razón'},
    {key: 'user', label:'Agregado por'}
  ],
  override: [
    {key: 'description', label:'Descripción'},
    {key: 'weeklyVolume', label:'Volumen procesable de la semana'},
    {key: 'factor', label:'Factor de override'},
    {key: 'exchange_rate', label:'Tipo de cambio'}
  ],
  qs_commissions:[
    {key:'total', label:'Total de parejas'},
    {key:'qs', label:'Qs'},
    {key:'fly', label:'F&B'},
    {key:'trs', label:'Trs'},
    {key:'exchange', label:'Intercambios'},
    {key:'rule', label:'Regla'},
    {key:'payed_qs',label:'Parejas pagadas'},
    // {key:'q_amount',label:'q_amount'},
    {key:'period',label:'Periodo'},
    {key:'will_be_payed', label:'¿Se pagará?'}

  ],
  trs:[
    {key:'trs', label:'Numero de trs'},
    {key:'amount', label:'Pago por cada pareja',money:true},
  ],
  fly_and_by:[
    {key:'trs', label:'Numero de F&B'},
    {key:'amount', label:'Pago por cada pareja',money:true},
  ],
  exchange:[
    {key:'exchange', label:'Numero de F&B'},
    {key:'amount', label:'Pago por cada pareja',money:true},
  ],
  chargebacks:[
    {key:'description', label:'Descripción'},
    {key:'quantity', label:'Cantidad'},
    {key:'USD', label:'USD'},
    {key:'date', label:'Fecha'},
    {key:'exchange', label:'Tipo de cambio'},
    {key:'cost', label:'Costo'},
    {key:'pending', label:'Pendiente', money: true},
  ],
  rounding:[
    { key: 'subtotal', label: 'Subtotal', money: true },
    { key: 'balance', label: 'Saldo redondeo', money: true },
    { key: 'apply', label: 'Aplica' },
    { key: 'newBalance', label: 'Saldo nuevo', money: true },
  ]
}
